<div class="container-modal-lateral">
  <div>
    <span class="title-modal-lateral">{{ visualizar ? 'Detalhes Operador' : 'Cadastrar Operador' }}</span>

    @if(!visualizar){
      <form [formGroup]="formGrupo" (ngSubmit)="salvar()">
        <div class="main-modal-lateral-edicao">
          <div class="container-edicao-modal-lateral">
            <app-slide-toggle-padrao [valor]="operador.ativo" (changeValue)="operador.ativo = $event; alteracaoService.camposAlterado()"></app-slide-toggle-padrao>

            <app-form-field formControlName="email" label="Email" heightFormField="35px" [disabled]="!!operador.id || !!operador.ldapHabilitado" (changeValue)="alteracaoService.camposAlterado()"></app-form-field>
            @if (usuarios.length > 1) {
              <div class="autocomplete">
                @for (usuario of usuarios; track $index) {
                  <mat-option (click)="this.operador = usuario; carregarInfoOperador(); usuarios = []">{{ usuario.nome }}</mat-option>
                }
              </div>
            }

            <app-form-field formControlName="nome" [disabled]="!!operador.ldapHabilitado" label="Nome" heightFormField="35px" (changeValue)="alteracaoService.camposAlterado()"></app-form-field>
          </div>

          <div class="container-edicao-modal-lateral" style="flex-direction: row; justify-content: space-between;">
            <app-select-one
              style="width: calc(100%)"
              formControlName="setor"
              label="Setor"
              [listaInput]="setores"
              campo="nome"
              widthFormField="100%"
              heightFormField="35px"
              (selecionarItem)="alteracaoService.camposAlterado()">
            </app-select-one>
          </div>

          <div class="container-edicao-modal-lateral" style="flex-direction: row; justify-content: space-between;">
            <app-form-field formControlName="telefone" style="width: 44%;" label="Telefone" heightFormField="35px" mask="(00) 90000-0000" (changeValue)="verificarInteracaoTelefoneUsuario($event)"></app-form-field>
            <app-form-field formControlName="cpf" style="width: 44%;" label="CPF" heightFormField="35px" mask="000.000.000-00" [disabled]="!!operador.id" (changeValue)="verificarInteracaoCpfUsuario($event)"></app-form-field>
          </div>

          <div class="container-edicao-modal-lateral">
            <span class="label">Foto</span>
            @if (imgOperador) {
              <img [src]="imgOperador" class="modal-lateral-imagem" (click)="fileInput.click()"
                   (keydown.enter)="fileInput.click()" tabindex="0" role="button" alt="Foto do operador" />
            } @else {
              @if (operador.extensaoImg && operador.uuid) {
                <img [src]="gerarUrl(operador.uuid, operador.extensaoImg, 'usuario-img')" class="modal-lateral-imagem" (click)="fileInput.click()"
                     (keydown.enter)="fileInput.click()" tabindex="0" role="button" alt="Foto do operador" />
              } @else {
                <app-button-padrao icon="add_photo_alternate" fontSize="24px" widthIcon="35px" heightIcon="35px" classIcon="material-icons-outlined"
                                   borderRightStyle="solid" borderRightWidth="5px" (buttonClick)="fileInput.click()"></app-button-padrao>
              }
            }
            <input type="file" accept="image/*" #fileInput (change)="selecionarImgOperador($event); alteracaoService.camposAlterado()" hidden="" />
          </div>
        </div>
      </form>
    }@else {
      <div class="main-modal-lateral-info">
        <div class="container-info-modal-lateral">
          <span class="label">Status</span>
          <span class="font-12 ellipse">{{operador.ativo ? 'Ativo' : 'Inativo'}}</span>
        </div>

        <div class="container-info-modal-lateral">
          <span class="label">Email</span>
          <span class="font-12 ellipse">{{operador.email}}</span>
        </div>

        <div class="container-info-modal-lateral">
          <span class="label">Nome</span>
          <span class="font-12 ellipse">{{operador.nome}}</span>
        </div>

        <div class="container-info-modal-lateral">
          <span class="label">Telefone</span>
          <span class="font-12 ellipse">{{operador.telefone | celularMask}}</span>
        </div>

        <div class="container-info-modal-lateral">
          <span class="label">CPF</span>
          <span class="font-12 ellipse">{{operador.cpf ? (operador.cpf! | cpfCnpjMask) : ''}}</span>
        </div>

        <div class="container-info-modal-lateral">
          <span class="label">Setor</span>
          <span class="font-12 ellipse">{{operador.setorDTO ? operador.setorDTO.nome : ''}}</span>
        </div>

        <div class="container-info-modal-lateral">
          <span class="label">Foto</span>
            @if (operador.extensaoImg && operador.uuid) {
              <img [src]="gerarUrl(operador.uuid, operador.extensaoImg, 'usuario-img')" class="modal-lateral-imagem" alt="Foto do operador" />
            } @else {
              <img src="./assets/icones/no-img-default.png" style="width: 25px; height: 25px" alt="Foto do operador" />
            }
        </div>

        <div class="topico-modal-lateral">
          <span class="label">Canais do Operador</span>
        </div>

        <div class="main-modal-lateral-info" style="margin: 0;">
          @if (operador.canais && operador.canais.length > 0) {
            @for (canal of operador.canais; track canal.id) {
              <span class="font-12 weight-400">{{ canal.nome }}</span>
            }
          } @else {
            <span class="font-12 weight-600"> Nenhum canal associada ao operador </span>
          }
        </div>
      </div>
    }
  </div>
    @if(!visualizar){
      <div class="botoes-modal-lateral">
        <app-button-padrao
          width="100%"
          label="Salvar"
          backgroundColor="var(--verde-padrao)"
          color="white"
          [backgroundColor]="formGrupo.invalid ? 'grey' : 'var(--verde-padrao)'"
          [color]="formGrupo.invalid ? 'dark-grey' : '#FFF'"
          [type]="'submit'"
          [disabled]="formGrupo.invalid"
          (buttonClick)="salvar()">
        </app-button-padrao>

        <app-button-padrao
          width="100%"
          label="Cancelar"
          backgroundColor="white"
          color="var(--vermelho-padrao)"
          (buttonClick)="cancelar()"
          borderColor="var(--vermelho-padrao)"
          borderStyle="solid"
          borderWidth="1px">
        </app-button-padrao>
      </div>
    }
</div>
